import { getPumpApi } from '@/gql';
import { TokenDetail } from '@/gql/pump/__generated__/request';
import { useEffect, useState } from 'react';

export interface useTokenDetailResult {
    tokenDetail?: TokenDetail;
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<TokenDetail | undefined>;
}

export const useTokenDetail = (tokenAddress: string): useTokenDetailResult => {
    const [tokenDetail, setTokenDetail] = useState<TokenDetail>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const getTokenDetail = async () => {
        if (!tokenAddress) {
            setTokenDetail(undefined);
            return undefined;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getPumpApi();
            const response = await api.tokenDetail({
                tokenId: tokenAddress,
            });
            if (response?.tokenDetail != null) {
                setTokenDetail(response.tokenDetail);
                return response.tokenDetail;
            } else {
                setTokenDetail(undefined);
                return undefined;
            }
        } catch (err) {
            console.error('Failed to fetch token detail:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch token detail'),
            );
            setTokenDetail(undefined);
            return undefined;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getTokenDetail();
    }, [tokenAddress]);

    return {
        tokenDetail,
        loading,
        error,
        refetch: getTokenDetail,
    };
};
